import { RespuestaResultadoComponent } from './respuesta-resultado/respuesta-resultado.component';
import { IonicModule } from '@ionic/angular';
import { CargandoComponent } from './cargando/cargando.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { PreloaderComponent } from './preloader/preloader.component';
import { SuccessComponent } from './success/success.component';
import { ErrorComponent } from './error/error.component';
import { LogoutComponent } from './logout/logout.component';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaldoComponent } from './saldo/saldo.component';
import { SaldoService } from '../service/saldo.service';
import { HeaderComponent } from './header/header.component';
import { MfaService } from '../service/mfa.service';
import { MfaActivateProccessComponent } from './mfa-activate-proccess/mfa-activate-proccess.component';
import { MfavalidateComponent } from './mfavalidate/mfavalidate.component';
import { MfaactivateComponentComponent } from './mfaactivate-component/mfaactivate-component.component';
import { MfaqrComponent } from './mfaqr/mfaqr.component';

@NgModule({
  declarations: [CargandoComponent,RespuestaResultadoComponent,PreloaderComponent,ErrorComponent,SuccessComponent,LogoutComponent,SaldoComponent,HeaderComponent,MfaqrComponent,MfaactivateComponentComponent,MfavalidateComponent,MfaActivateProccessComponent],
  exports: [CargandoComponent,RespuestaResultadoComponent,PreloaderComponent,ErrorComponent,SuccessComponent,LogoutComponent,SaldoComponent,HeaderComponent,MfaqrComponent,MfaactivateComponentComponent,MfavalidateComponent,MfaActivateProccessComponent],
  imports: [
    IonicModule,
    CommonModule
  ],
  providers:[
    SaldoService,
    MfaService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class ComponentsModule {
  
}
